export default "__VITE_ASSET__BVOaw54o__"